import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/themes.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './firebase'; // Import Firebase configuration
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);

if (process.env.NODE_ENV !== 'production') {
  window.addEventListener('unhandledrejection', (event) => {
    const err = event?.reason;
    console.error('Unhandled promise rejection', {
      code: err?.code || err?.name,
      message: err?.message,
      error: err
    });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
